import {
  Companion_getInstance2tq82jyrde4r as Companion_getInstance,
  Notification36ye7lys64zyi as Notification,
  NotificationContent14rxxdz7igy9l as NotificationContent,
  Event1xu0tgxxbb919 as Event,
} from './shared.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareNotificationFields() {
  var tmp = Companion_getInstance().i8m(NothingSerializer(), NothingSerializer());
  properties(tmp, prepareNotificationFields$lambda);
}
function Notification_user$name$delegate$lambda() {
  return Companion_getInstance().i8m(NothingSerializer(), NothingSerializer()).az().v11(2);
}
function Notification_user$_get_name_$ref_fy5xp0() {
  return (p0) => p0.k20();
}
function Notification_user$_get_serializer_$ref_f7i9il() {
  return (p0) => p0.j2j();
}
function Notification_user$_get_annotations_$ref_t6csmv() {
  return (p0) => p0.bz();
}
var Notification_userClass;
function Notification_user() {
  if (Notification_userClass === VOID) {
    class $ {
      constructor(uID, cONTENT) {
        var tmp = this;
        tmp.j8m_1 = lazy(Notification_user$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k8m_1 = lazy(() => {
          var tmp = Companion_getInstance().i8m(uID, cONTENT);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.l8m_1 = lazy(() => Companion_getInstance().i8m(uID, cONTENT).az().x11(2));
      }
      k20() {
        var tmp0 = this.j8m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Notification_user$_get_name_$ref_fy5xp0(), null);
        return tmp0.f2();
      }
      m8m(receiver) {
        return receiver.p8m_1;
      }
      m2j(receiver) {
        return this.m8m(receiver instanceof Notification() ? receiver : THROW_CCE());
      }
      w8m(receiver, value) {
        return receiver.x8m(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Notification() ? receiver : THROW_CCE();
        return this.w8m(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k8m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Notification_user$_get_serializer_$ref_f7i9il(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l8m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Notification_user$_get_annotations_$ref_t6csmv(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 871131808;
      }
      equals(other) {
        return other instanceof Notification_user();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Notification_user', VOID, VOID, [SerializableProperty()]);
    Notification_userClass = $;
  }
  return Notification_userClass;
}
function Notification_content$name$delegate$lambda() {
  return Companion_getInstance().i8m(NothingSerializer(), NothingSerializer()).az().v11(3);
}
function Notification_content$_get_name_$ref_lo5yz2() {
  return (p0) => p0.k20();
}
function Notification_content$_get_serializer_$ref_swf4iv() {
  return (p0) => p0.j2j();
}
function Notification_content$_get_annotations_$ref_rfz60t() {
  return (p0) => p0.bz();
}
var Notification_contentClass;
function Notification_content() {
  if (Notification_contentClass === VOID) {
    class $ {
      constructor(uID, cONTENT) {
        var tmp = this;
        tmp.y8m_1 = lazy(Notification_content$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z8m_1 = lazy(() => {
          var tmp = Companion_getInstance().i8m(uID, cONTENT);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.a8n_1 = lazy(() => Companion_getInstance().i8m(uID, cONTENT).az().x11(3));
      }
      k20() {
        var tmp0 = this.y8m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Notification_content$_get_name_$ref_lo5yz2(), null);
        return tmp0.f2();
      }
      m8m(receiver) {
        return receiver.q8m_1;
      }
      m2j(receiver) {
        return this.m8m(receiver instanceof Notification() ? receiver : THROW_CCE());
      }
      b8n(receiver, value) {
        return receiver.x8m(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Notification() ? receiver : THROW_CCE();
        return this.b8n(tmp, (!(value == null) ? isInterface(value, NotificationContent()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z8m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Notification_content$_get_serializer_$ref_swf4iv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Notification_content$_get_annotations_$ref_rfz60t(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 192231346;
      }
      equals(other) {
        return other instanceof Notification_content();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Notification_content', VOID, VOID, [SerializableProperty()]);
    Notification_contentClass = $;
  }
  return Notification_contentClass;
}
function Notification_sendAt$name$delegate$lambda() {
  return Companion_getInstance().i8m(NothingSerializer(), NothingSerializer()).az().v11(4);
}
function Notification_sendAt$_get_name_$ref_d86am4() {
  return (p0) => p0.k20();
}
function Notification_sendAt$_get_serializer_$ref_j4qf6r() {
  return (p0) => p0.j2j();
}
function Notification_sendAt$_get_annotations_$ref_u3kcg7() {
  return (p0) => p0.bz();
}
var Notification_sendAtClass;
function Notification_sendAt() {
  if (Notification_sendAtClass === VOID) {
    class $ {
      constructor(uID, cONTENT) {
        var tmp = this;
        tmp.c8n_1 = lazy(Notification_sendAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d8n_1 = lazy(() => {
          var tmp = Companion_getInstance().i8m(uID, cONTENT);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.e8n_1 = lazy(() => Companion_getInstance().i8m(uID, cONTENT).az().x11(4));
      }
      k20() {
        var tmp0 = this.c8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Notification_sendAt$_get_name_$ref_d86am4(), null);
        return tmp0.f2();
      }
      m8m(receiver) {
        return receiver.r8m_1;
      }
      m2j(receiver) {
        return this.m8m(receiver instanceof Notification() ? receiver : THROW_CCE());
      }
      f8n(receiver, value) {
        return receiver.x8m(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Notification() ? receiver : THROW_CCE();
        return this.f8n(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Notification_sendAt$_get_serializer_$ref_j4qf6r(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Notification_sendAt$_get_annotations_$ref_u3kcg7(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -1555529072;
      }
      equals(other) {
        return other instanceof Notification_sendAt();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Notification_sendAt', VOID, VOID, [SerializableProperty()]);
    Notification_sendAtClass = $;
  }
  return Notification_sendAtClass;
}
function Notification__id$name$delegate$lambda() {
  return Companion_getInstance().i8m(NothingSerializer(), NothingSerializer()).az().v11(0);
}
function Notification__id$_get_name_$ref_9bl637() {
  return (p0) => p0.k20();
}
function Notification__id$_get_serializer_$ref_47g3cq() {
  return (p0) => p0.j2j();
}
function Notification__id$_get_annotations_$ref_4gbuiq() {
  return (p0) => p0.bz();
}
var Notification__idClass;
function Notification__id() {
  if (Notification__idClass === VOID) {
    class $ {
      constructor(uID, cONTENT) {
        var tmp = this;
        tmp.g8n_1 = lazy(Notification__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h8n_1 = lazy(() => {
          var tmp = Companion_getInstance().i8m(uID, cONTENT);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.i8n_1 = lazy(() => Companion_getInstance().i8m(uID, cONTENT).az().x11(0));
        this.j8n_1 = Companion_getInstance_0().m2p();
        this.k8n_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.g8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Notification__id$_get_name_$ref_9bl637(), null);
        return tmp0.f2();
      }
      m8m(receiver) {
        return receiver.n8m_1;
      }
      m2j(receiver) {
        return this.m8m(receiver instanceof Notification() ? receiver : THROW_CCE());
      }
      l8n(receiver, value) {
        return receiver.x8m(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Notification() ? receiver : THROW_CCE();
        return this.l8n(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Notification__id$_get_serializer_$ref_47g3cq(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Notification__id$_get_annotations_$ref_4gbuiq(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 762487441;
      }
      equals(other) {
        return other instanceof Notification__id();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Notification__id', VOID, VOID, [SerializableProperty()]);
    Notification__idClass = $;
  }
  return Notification__idClass;
}
function Notification_event$name$delegate$lambda() {
  return Companion_getInstance().i8m(NothingSerializer(), NothingSerializer()).az().v11(1);
}
function Notification_event$_get_name_$ref_1gkglp() {
  return (p0) => p0.k20();
}
function Notification_event$_get_serializer_$ref_y5yi8q() {
  return (p0) => p0.j2j();
}
function Notification_event$_get_annotations_$ref_9rpyea() {
  return (p0) => p0.bz();
}
var Notification_eventClass;
function Notification_event() {
  if (Notification_eventClass === VOID) {
    class $ {
      constructor(uID, cONTENT) {
        var tmp = this;
        tmp.m8n_1 = lazy(Notification_event$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n8n_1 = lazy(() => {
          var tmp = Companion_getInstance().i8m(uID, cONTENT);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.o8n_1 = lazy(() => Companion_getInstance().i8m(uID, cONTENT).az().x11(1));
      }
      k20() {
        var tmp0 = this.m8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Notification_event$_get_name_$ref_1gkglp(), null);
        return tmp0.f2();
      }
      m8m(receiver) {
        return receiver.o8m_1;
      }
      m2j(receiver) {
        return this.m8m(receiver instanceof Notification() ? receiver : THROW_CCE());
      }
      p8n(receiver, value) {
        return receiver.x8m(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Notification() ? receiver : THROW_CCE();
        return this.p8n(tmp, value instanceof Event() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Notification_event$_get_serializer_$ref_y5yi8q(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Notification_event$_get_annotations_$ref_9rpyea(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -531776079;
      }
      equals(other) {
        return other instanceof Notification_event();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Notification_event', VOID, VOID, [SerializableProperty()]);
    Notification_eventClass = $;
  }
  return Notification_eventClass;
}
function Notification_email$name$delegate$lambda() {
  return Companion_getInstance().i8m(NothingSerializer(), NothingSerializer()).az().v11(5);
}
function Notification_email$_get_name_$ref_6owfrf() {
  return (p0) => p0.k20();
}
function Notification_email$_get_serializer_$ref_jz5010() {
  return (p0) => p0.j2j();
}
function Notification_email$_get_annotations_$ref_ywpijk() {
  return (p0) => p0.bz();
}
var Notification_emailClass;
function Notification_email() {
  if (Notification_emailClass === VOID) {
    class $ {
      constructor(uID, cONTENT) {
        var tmp = this;
        tmp.q8n_1 = lazy(Notification_email$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r8n_1 = lazy(() => {
          var tmp = Companion_getInstance().i8m(uID, cONTENT);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.s8n_1 = lazy(() => Companion_getInstance().i8m(uID, cONTENT).az().x11(5));
        this.t8n_1 = null;
        this.u8n_1 = 'null';
      }
      k20() {
        var tmp0 = this.q8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Notification_email$_get_name_$ref_6owfrf(), null);
        return tmp0.f2();
      }
      m8m(receiver) {
        return receiver.s8m_1;
      }
      m2j(receiver) {
        return this.m8m(receiver instanceof Notification() ? receiver : THROW_CCE());
      }
      v8n(receiver, value) {
        return receiver.x8m(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Notification() ? receiver : THROW_CCE();
        return this.v8n(tmp, (value == null ? true : typeof value === 'boolean') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Notification_email$_get_serializer_$ref_jz5010(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Notification_email$_get_annotations_$ref_ywpijk(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -540211985;
      }
      equals(other) {
        return other instanceof Notification_email();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Notification_email', VOID, VOID, [SerializableProperty()]);
    Notification_emailClass = $;
  }
  return Notification_emailClass;
}
function Notification_push$name$delegate$lambda() {
  return Companion_getInstance().i8m(NothingSerializer(), NothingSerializer()).az().v11(6);
}
function Notification_push$_get_name_$ref_oduwf9() {
  return (p0) => p0.k20();
}
function Notification_push$_get_serializer_$ref_soj83i() {
  return (p0) => p0.j2j();
}
function Notification_push$_get_annotations_$ref_kni8sm() {
  return (p0) => p0.bz();
}
var Notification_pushClass;
function Notification_push() {
  if (Notification_pushClass === VOID) {
    class $ {
      constructor(uID, cONTENT) {
        var tmp = this;
        tmp.w8n_1 = lazy(Notification_push$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x8n_1 = lazy(() => {
          var tmp = Companion_getInstance().i8m(uID, cONTENT);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.y8n_1 = lazy(() => Companion_getInstance().i8m(uID, cONTENT).az().x11(6));
        this.z8n_1 = null;
        this.a8o_1 = 'null';
      }
      k20() {
        var tmp0 = this.w8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Notification_push$_get_name_$ref_oduwf9(), null);
        return tmp0.f2();
      }
      m8m(receiver) {
        return receiver.t8m_1;
      }
      m2j(receiver) {
        return this.m8m(receiver instanceof Notification() ? receiver : THROW_CCE());
      }
      v8n(receiver, value) {
        return receiver.x8m(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Notification() ? receiver : THROW_CCE();
        return this.v8n(tmp, (value == null ? true : typeof value === 'boolean') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Notification_push$_get_serializer_$ref_soj83i(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y8n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Notification_push$_get_annotations_$ref_kni8sm(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 866586929;
      }
      equals(other) {
        return other instanceof Notification_push();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Notification_push', VOID, VOID, [SerializableProperty()]);
    Notification_pushClass = $;
  }
  return Notification_pushClass;
}
function Notification_sms$name$delegate$lambda() {
  return Companion_getInstance().i8m(NothingSerializer(), NothingSerializer()).az().v11(7);
}
function Notification_sms$_get_name_$ref_l34lua() {
  return (p0) => p0.k20();
}
function Notification_sms$_get_serializer_$ref_nfcb3t() {
  return (p0) => p0.j2j();
}
function Notification_sms$_get_annotations_$ref_w0631f() {
  return (p0) => p0.bz();
}
var Notification_smsClass;
function Notification_sms() {
  if (Notification_smsClass === VOID) {
    class $ {
      constructor(uID, cONTENT) {
        var tmp = this;
        tmp.b8o_1 = lazy(Notification_sms$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c8o_1 = lazy(() => {
          var tmp = Companion_getInstance().i8m(uID, cONTENT);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.d8o_1 = lazy(() => Companion_getInstance().i8m(uID, cONTENT).az().x11(7));
        this.e8o_1 = null;
        this.f8o_1 = 'null';
      }
      k20() {
        var tmp0 = this.b8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Notification_sms$_get_name_$ref_l34lua(), null);
        return tmp0.f2();
      }
      m8m(receiver) {
        return receiver.u8m_1;
      }
      m2j(receiver) {
        return this.m8m(receiver instanceof Notification() ? receiver : THROW_CCE());
      }
      v8n(receiver, value) {
        return receiver.x8m(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Notification() ? receiver : THROW_CCE();
        return this.v8n(tmp, (value == null ? true : typeof value === 'boolean') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Notification_sms$_get_serializer_$ref_nfcb3t(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Notification_sms$_get_annotations_$ref_w0631f(), null);
        return tmp0.f2();
      }
      hashCode() {
        return 763087570;
      }
      equals(other) {
        return other instanceof Notification_sms();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Notification_sms', VOID, VOID, [SerializableProperty()]);
    Notification_smsClass = $;
  }
  return Notification_smsClass;
}
function Notification_inAppOnlySent$name$delegate$lambda() {
  return Companion_getInstance().i8m(NothingSerializer(), NothingSerializer()).az().v11(8);
}
function Notification_inAppOnlySent$_get_name_$ref_vni6xz() {
  return (p0) => p0.k20();
}
function Notification_inAppOnlySent$_get_serializer_$ref_2oib0g() {
  return (p0) => p0.j2j();
}
function Notification_inAppOnlySent$_get_annotations_$ref_411n3w() {
  return (p0) => p0.bz();
}
var Notification_inAppOnlySentClass;
function Notification_inAppOnlySent() {
  if (Notification_inAppOnlySentClass === VOID) {
    class $ {
      constructor(uID, cONTENT) {
        var tmp = this;
        tmp.g8o_1 = lazy(Notification_inAppOnlySent$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h8o_1 = lazy(() => {
          var tmp = Companion_getInstance().i8m(uID, cONTENT);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.i8o_1 = lazy(() => Companion_getInstance().i8m(uID, cONTENT).az().x11(8));
        this.j8o_1 = false;
        this.k8o_1 = 'false // This is used to notify web sockets that the notification should be sent in-app if no other method is specified';
      }
      k20() {
        var tmp0 = this.g8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Notification_inAppOnlySent$_get_name_$ref_vni6xz(), null);
        return tmp0.f2();
      }
      m8m(receiver) {
        return receiver.v8m_1;
      }
      m2j(receiver) {
        return this.m8m(receiver instanceof Notification() ? receiver : THROW_CCE());
      }
      l8o(receiver, value) {
        return receiver.x8m(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Notification() ? receiver : THROW_CCE();
        return this.l8o(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Notification_inAppOnlySent$_get_serializer_$ref_2oib0g(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Notification_inAppOnlySent$_get_annotations_$ref_411n3w(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -837736245;
      }
      equals(other) {
        return other instanceof Notification_inAppOnlySent();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'Notification_inAppOnlySent', VOID, VOID, [SerializableProperty()]);
    Notification_inAppOnlySentClass = $;
  }
  return Notification_inAppOnlySentClass;
}
function prepareNotificationFields$lambda(args) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new (Notification__id())(args[0], args[1]), new (Notification_event())(args[0], args[1]), new (Notification_user())(args[0], args[1]), new (Notification_content())(args[0], args[1]), new (Notification_sendAt())(args[0], args[1]), new (Notification_email())(args[0], args[1]), new (Notification_push())(args[0], args[1]), new (Notification_sms())(args[0], args[1]), new (Notification_inAppOnlySent())(args[0], args[1])];
}
//region block: exports
export {
  Notification_content as Notification_contente278hdr7b28t,
  Notification_sendAt as Notification_sendAt157qjqtdxcsgo,
  Notification_user as Notification_usero4k05uhx7qoy,
  prepareNotificationFields as prepareNotificationFields1m7m2qdauumrw,
};
//endregion

//# sourceMappingURL=NotificationFields.mjs.map
